export default "__VITE_ASSET__a4132d10__"